import { render, staticRenderFns } from "./AthleteScheduleCard.vue?vue&type=template&id=5b3537f4&scoped=true&"
import script from "./AthleteScheduleCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteScheduleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3537f4",
  null
  
)

export default component.exports